import { Fragment } from 'react'
import MarkdownRenderer from '@/components/ChatResponseElements/MarkdownRenderer'
import PhaseListBlock from '@/components/ChatResponseElements/PhaseListBlock'
import { inferResponseBlocksMemo } from '@/features/chat/blockInference/memoizedInference'

/**
 * Renders the response as inferred segments (Stage 4).
 *
 * Only `phaseList` is inferred — the one convention Stage 0 evidence supported.
 * Anything a rule declines becomes a `markdown` segment and goes through the
 * Stage 2 renderer, so the worst realistic failure is a missing card, never a
 * missing response.
 *
 * Unknown segment types render as nothing in `BlockRenderer`, so this switch is
 * exhaustive by construction rather than by registry lookup.
 */
const BLOCKS = { phaseList: PhaseListBlock }

export default function Phase1InferredText({ text, citations }) {
  const segments = inferResponseBlocksMemo(text)
  if (!segments.length) return null

  return segments.map((segment) => {
    const key = `seg-${segment.span[0]}-${segment.span[1]}`
    if (segment.type === 'markdown') {
      return <MarkdownRenderer key={key} text={segment.text} citations={citations} />
    }
    const Block = BLOCKS[segment.type]
    if (!Block) return null
    return (
      <Fragment key={key}>
        <Block block={segment} />
      </Fragment>
    )
  })
}
